import { Inline, Tag } from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import {
  type InvoiceSyncStatus,
  InvoiceSyncStatusTarget,
  InvoiceSyncStatusType,
} from '@omnipresentgroup/types';
import { useState } from 'react';

import { XeroErrorModal } from './XeroErrorModal';

const ERROR_TAG_LABEL = 'Error';

type XeroStatusCellProps = {
  syncStatuses?: InvoiceSyncStatus[];
};

export const XeroStatusCell = ({ syncStatuses = [] }: XeroStatusCellProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const xeroSyncStatus = syncStatuses.find(
    (syncStatus) => syncStatus.syncTarget === InvoiceSyncStatusTarget.XERO,
  );

  if (!xeroSyncStatus) {
    return null;
  }

  const { status: xeroStatus, reason } = xeroSyncStatus;

  const renderSuccessStatus = () => (
    <Tag id="xero-status-tag" intent="success">
      {toSentenceCase(xeroStatus)}
    </Tag>
  );

  const renderAbortedStatus = () => (
    <>
      <Inline align="center" gap="0">
        <Tag
          id="xero-error-tag"
          intent="error"
          onClick={() => setModalOpen(true)}
        >
          {ERROR_TAG_LABEL}
        </Tag>
      </Inline>
      <XeroErrorModal
        modalProps={{
          open: modalOpen,
          onOpenChange: setModalOpen,
        }}
        handleClose={() => setModalOpen(false)}
        invoiceSyncStatusReason={reason}
      />
    </>
  );

  switch (xeroStatus) {
    case InvoiceSyncStatusType.SUCCESS: {
      return renderSuccessStatus();
    }
    case InvoiceSyncStatusType.ABORTED: {
      return renderAbortedStatus();
    }
    default: {
      return null;
    }
  }
};
